var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRightBlack = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.29308 16.7072C9.10561 16.5197 9.00029 16.2654 9.00029 16.0002C9.00029 15.735 9.10561 15.4807 9.29308 15.2932L12.5861 12.0002L9.29308 8.70721C9.19757 8.61497 9.12139 8.50462 9.06898 8.38262C9.01657 8.26061 8.98898 8.12939 8.98783 7.99661C8.98668 7.86384 9.01198 7.73216 9.06226 7.60926C9.11254 7.48636 9.18679 7.37471 9.28069 7.28082C9.37458 7.18693 9.48623 7.11267 9.60913 7.06239C9.73202 7.01211 9.8637 6.98681 9.99648 6.98796C10.1293 6.98912 10.2605 7.0167 10.3825 7.06911C10.5045 7.12152 10.6148 7.1977 10.7071 7.29321L14.7071 11.2932C14.8946 11.4807 14.9999 11.735 14.9999 12.0002C14.9999 12.2654 14.8946 12.5197 14.7071 12.7072L10.7071 16.7072C10.5196 16.8947 10.2652 17 10.0001 17C9.73492 17 9.48061 16.8947 9.29308 16.7072Z",
  fill: "#222735"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right-black.2a7bd607c619eea5612bbc6e93b85d69.svg";